import React, { HTMLAttributes } from "react";
import classNames from "classnames";

export interface ModuleCaptionProps extends HTMLAttributes<HTMLDivElement> {
}

const ModuleCaption: React.FC<ModuleCaptionProps> = ({ children, className, ...rest }) => {
   return (<div className={classNames("management-module-caption", className)} {...rest}>{children}</div>)
}

export default ModuleCaption;